import React, { useState } from 'react';
import classNames from 'classnames';
import { noop } from '../../lib/noop';
import { ForgotPassword } from '../ForgotPassword';
import { Register } from './Register';
import { SignIn } from './SignIn';

import './Authentication.scss';

type AuthenticationProps = {
  fullPage?: boolean;
  modal?: boolean;
  onAuth?: () => void;
  showAuthModal?: () => void;
  hideAuthModal?: () => void;
};

const SIGN_IN_TAB = 'SIGN IN';
const REGISTER_TAB = 'REGISTER';
const FORGOT_PASSWORD_TAB = 'FORGOT PASSWORD';

export const Authentication: React.FC<AuthenticationProps> = ({
  fullPage = false,
  modal = false,
  onAuth = noop,
  showAuthModal,
  hideAuthModal
}) => {
  const [activeTab, setActiveTab] = useState(SIGN_IN_TAB);
  const registerActive = activeTab === REGISTER_TAB;
  const signInActive = activeTab === SIGN_IN_TAB;
  const forgotPasswordActive = activeTab === FORGOT_PASSWORD_TAB;
  const className = classNames('Authentication', {
    'Authentication--fullPage': fullPage,
    'Authentication--modal': modal
  });
  const headerClassName = classNames('Authentication__header', {
    'Authentication__header--hidden': forgotPasswordActive
  });
  const registerTabClassName = classNames('Authentication__tab', {
    'Authentication__tab--active': registerActive
  });
  const signInTabClassName = classNames('Authentication__tab', {
    'Authentication__tab--active': signInActive
  });
  const registerSectionClassName = classNames('Authentication__section', {
    'Authentication__section--active': registerActive
  });
  const signInSectionClassName = classNames('Authentication__section', {
    'Authentication__section--active': signInActive
  });
  const forgotPasswordSectionClassName = classNames('Authentication__section', {
    'Authentication__section--active': forgotPasswordActive
  });
  const handleClickForgotPassword = !fullPage ? () => setActiveTab(FORGOT_PASSWORD_TAB) : undefined;
  const showForgotPassword = !fullPage && forgotPasswordActive;
  const showSignInRegister = fullPage || !forgotPasswordActive;

  return (
    <div className={className} data-testid="authentication">
      <div className={headerClassName}>
        <button
          className={registerTabClassName}
          data-testid="registerTab"
          onClick={() => setActiveTab(REGISTER_TAB)}
        >
          {REGISTER_TAB}
        </button>
        <button
          className={signInTabClassName}
          data-testid="signInTab"
          onClick={() => setActiveTab(SIGN_IN_TAB)}
        >
          {SIGN_IN_TAB}
        </button>
      </div>

      <div className="Authentication__content">
        {showSignInRegister && (
          <>
            <Register
              className={registerSectionClassName}
              onAuth={onAuth}
              showAuthModal={showAuthModal}
              hideAuthModal={hideAuthModal}
            />
            <SignIn
              className={signInSectionClassName}
              onAuth={onAuth}
              onClickForgotPassword={handleClickForgotPassword}
              showAuthModal={showAuthModal}
              hideAuthModal={hideAuthModal}
            />
          </>
        )}

        {showForgotPassword && (
          <ForgotPassword
            className={forgotPasswordSectionClassName}
            onClickSignIn={() => setActiveTab(SIGN_IN_TAB)}
          />
        )}
      </div>
    </div>
  );
};
